export const CABINET_QUOTE_STATUSES = [
  "draft",
  "in_review",
  "pending_customer",
  "approved",
  "rejected",
  "archived",
];

export const normalizeCabinetQuoteStatuses = (statuses) => {
  const source = Array.isArray(statuses) ? statuses : CABINET_QUOTE_STATUSES;
  const normalized = source
    .map((status) => String(status || "").trim())
    .filter(Boolean);

  if (normalized.length === 0) {
    return [...CABINET_QUOTE_STATUSES];
  }

  return [...new Set(normalized)];
};

export const CABINET_COLLABORATOR_PERMISSIONS = [
  "full_access",
  "checklist_access",
  "quote_revisions_access",
  "read_only",
];

export const CABINET_CHAT_CHANNELS = ["internal", "external"];
